import {
    AccountSms,
    DomainInitPayload,
    RadioInformationModel,
} from '@sxm-de/dev-kits/web-sdk/types';
import { logErrorFromMicroservicesSdk } from '@sxm-de/dev-kits/web-sdk/utils';
import { getRadioInformationForLicensePlateSms } from '@sxm-de/dev-kits/web-sdk/domains/devices';

interface GetDeviceInfoByLicensePlateSmsFnPayload {
    licensePlate: string;
    state: string;
}

export type GetDeviceInfoByLicensePlateSmsFn = (
    payload: GetDeviceInfoByLicensePlateSmsFnPayload,
) => Promise<{
    radioInfo: RadioInformationModel['deviceInformation'];
    account: AccountSms;
}>;

export function initGetDeviceInfoByLicensePlateSmsFn({
    dependencies,
}: DomainInitPayload): GetDeviceInfoByLicensePlateSmsFn {
    const { microservicesSdk } = dependencies;
    return async ({
        licensePlate,
        state,
    }: GetDeviceInfoByLicensePlateSmsFnPayload) => {
        let radioInfo: RadioInformationModel | null = null;
        let account: AccountSms | null = null;

        radioInfo = await getRadioInformationForLicensePlateSms(
            { licensePlate, state },
            dependencies,
        );

        if (!radioInfo) {
            throw new Error('DEVICE_NOT_FOUND');
        }
        try {
            account = await microservicesSdk.domains.account.nonPii({
                radioId: radioInfo.deviceInformation.radioId,
            });
        } catch (error: any) {
            logErrorFromMicroservicesSdk(error, dependencies);
            throw new Error('SYSTEM');
        }
        /**
         * TODO:
         * Add analytics.
         */
        return {
            radioInfo: radioInfo.deviceInformation,
            account,
        };
    };
}
